import { giphyBlue, giphyIndigo, giphyPurple } from '@giphy/js-brand'
import { TitleLarge } from '@giphy/react-giphy-brand'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    padding-top: 50px;
`

const Sticker = styled.img`
    height: 150px;
    left: 50%;
    margin-left: -75px;
    position: absolute;
    top: -60px;
    width: 150px;
`

const Title = styled(TitleLarge)`
    margin-bottom: 50px;
    text-align: center;
`

const Instructions = styled.div`
    display: flex;
    margin-bottom: 60px;
    width: 100%;
`

const Step = styled.div`
    display: flex;
    font-size: 18px;
    margin-right: 60px;
    width: 100%;

    &:last-child {
        margin-right: 0;
    }

    a {
        color: ${giphyBlue};
        text-decoration: underline;
    }

    p {
        line-height: 1.4;
        margin: 0;
    }
`

const StepNumber = styled.div`
    align-items: center;
    background: linear-gradient(45deg, ${giphyIndigo} 0%, ${giphyPurple} 100%);
    border-radius: 50%;
    color: #fff;
    display: flex;
    flex-shrink: 0;
    font-family: 'nexablack', sans-serif;
    height: 32px;
    margin-right: 15px;
    margin-top: -5px;
    justify-content: center;
    text-indent: 1px;
    width: 32px;
`

const ZoomMakerDownloadInstructions = () => {
    return (
        <Container>
            <Sticker src="https://media.giphy.com/media/ZdNlmHHr7czumQPvNE/200.gif" alt="" />
            <Title>Go use your new backdrop!</Title>
            <Instructions>
                <Step>
                    <StepNumber>1</StepNumber>
                    <p>
                        In a Zoom call, click the arrow next to the camera icon at the bottom left of the call window.
                        Click &quot;Choose Virtual Background&quot;
                    </p>
                </Step>
                <Step>
                    <StepNumber>2</StepNumber>
                    <p>
                        Click the plus icon and select your downloaded MP4 File! For more info on Zoom Virtual
                        Backgrounds,{' '}
                        <a
                            href="https://support.zoom.us/hc/en-us/articles/210707503-Virtual-Background"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            click here
                        </a>
                        .
                    </p>
                </Step>
            </Instructions>
        </Container>
    )
}

export default ZoomMakerDownloadInstructions
